import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, finalize } from 'rxjs/operators';

import { Language } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class LanguagesService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getAllLanguages(loader: string): Observable<Array<Language>> {
    this.loadersService.show(loader);
    return this.http
      .get<Array<Language>>(this.baseUrl + '/languages')
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getAllPublishedLanguages(loader: string): Observable<Array<Language>> {
    this.loadersService.show(loader);
    return this.http
      .get<Array<Language>>(this.baseUrl + '/languages/published')
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  getAllSelectedLanguages(loader: string): Observable<Array<Language>> {
    this.loadersService.show(loader);
    return this.http
      .get<Array<Language>>(this.baseUrl + '/languages/selected')
      .pipe(finalize(() => this.loadersService.hide(loader)));
  }

  selectSingleLanguages(id: string, loader: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.get(this.baseUrl + `/languages/${id}/select`, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }

  unselectSingleLanguages(id: string, loader: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.get<Array<Language>>(this.baseUrl + `/languages/${id}/unselect`, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }

  publishSingleLanguages(id: string, loader: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.get(this.baseUrl + `/languages/${id}/publish`, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }

  unpublishSingleLanguages(id: string, loader: string): Observable<boolean> {
    this.loadersService.show(loader);
    return this.http.get<Array<Language>>(this.baseUrl + `/languages/${id}/unpublish`, { observe: 'response' }).pipe(
      map((response) => this.isStatusSucceed(response.status)),
      finalize(() => this.loadersService.hide(loader))
    );
  }
}
